import {
  APPEND_ITEMS,
  STORE_ITEMS
} from '../actions/types'

const itemsReducer = function (state = {
  items: []
}, action) {
  switch (action.type) {
    case STORE_ITEMS:
      return {
        ...state,
        items: action.items,
        hasNext: action.hasNext
      }
    case APPEND_ITEMS:
      return {
        ...state,
        items: [...state.items, ...action.items],
        hasNext: action.hasNext
      }
    default:
      return state
  }
}
export default itemsReducer



// WEBPACK FOOTER //
// /app/js/reducers/itemsReducer.js